import React from 'react';
import BigTooltip from "../../Tooltip/BigTooltipBox";
import styled from "styled-components";

const ReletiveDiv = styled.div`
  position: relative;
  margin: ${props => props.margin || 0};
`;

const ChampionImage = styled.img`
    border-radius: 6px;
`;

const AbsoluteSpan = styled.span`
  text-align: center;
  width: 2.5ch;
  position: absolute;
  padding: 2px;
  font-size: 12px;
  background-color:  rgba(0,0,0,0.8);
  bottom: 0;
  right: 0;
`;

const ChampionPassiveImage = ({tooltip, version, img, absoluteText, width = 36, height = 36, margin,reverse}) => {
    return (
        <ReletiveDiv margin={margin}>
            <BigTooltip
                reverse={reverse}
                tooltipText={`${tooltip}`}
                textAlign={'left'}
            >
                <ChampionImage
                    loaindg={'lazy'}
                    width={width}
                    height={height}
                    src={`${process.env.REACT_APP_IMG}${version}/img/passive/${img?.replace('.png','')}__56.webp`}
                    onError={(e) => e.target.src = "/images/icon_non_item.svg"}
                />
                {absoluteText && <AbsoluteSpan>{absoluteText}</AbsoluteSpan>}
            </BigTooltip>
        </ReletiveDiv>
    );
};

export default ChampionPassiveImage;
